import React, { useEffect, useState } from 'react';
import "./Details.css";
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import { Icon } from 'react-icons-kit';
import { menu } from 'react-icons-kit/feather/menu';
import { eye } from 'react-icons-kit/feather/eye';
import { arrowUpRight } from 'react-icons-kit/feather/arrowUpRight'
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import { useJwt } from "react-jwt";
import { GetProductById } from '../apiconfig/authService';

function ViewProduct() {
    const navigate = useNavigate();
    const { _, isExpired } = useJwt(localStorage.getItem('accessToken'));
    if (isExpired)
        navigate('/');

    const [subcategoryData, setSubcategoryData] = useState([]);
    const { subcategoryid } = useParams();

    const [productData, setProductData] = useState(null);
    const { productid } = useParams();
    console.log(productData);

    const formatUTCDate = (utcDateString) => {
        const date = new Date(utcDateString);
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZoneName: 'short',
        };
        const readableFormat = date.toLocaleString(undefined, options);
        return readableFormat.substring(0, readableFormat.length - 9);
    };

    useEffect(() => {
        (
            async () => {
                try {
                    const response = await GetProductById(productid, localStorage.getItem('accessToken'));
                    setProductData(response.data.product);
                } catch (error) {
                    console.log(error);
                }
            }
        )();
    }, []);


    return (
        <div className="dashboard-content">
            {/* <div className="mobileOption d-flex align-items-center justify-content-between">
                <div  className="buyMore"><img className="img-fluid" src={logoImg} alt=""/></div>
                <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
            </div> */}
            <Sidebar />
            <div className="body-cart tab-content dasContent p-4 bg-white rounded">
                <div className="d-flex justify-content-between align-items-center pb-4 border-bottom mb-4">
                    <h1 className="heading h4 mb-0 fw-bold">Product Details</h1>
                    <div className="d-inline-flex gap-2">
                        <NavLink to="/product" className="btn btn-primary addSeller"><Icon className="eye" icon={eye} size={18} /> View All</NavLink>
                        <NavLink to={`/editProduct/${productid}`} className="btn btn-primary addSeller"><Icon className="arrowUpRight" icon={arrowUpRight} size={18} /> Edit</NavLink>
                    </div>
                </div>
                <div className="detailsBox">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover w-100">
                                    <tbody>
                                        <tr>
                                            <th>Name</th>
                                            <td>{productData?._doc?.name}</td>
                                        </tr>
                                        <tr>
                                            <th>Weight</th>
                                            <td>{productData?._doc?.weight}</td>
                                        </tr>
                                        <tr>
                                            <th>Category</th>
                                            <td>{productData?.categoryInfo?.name}</td>
                                        </tr>
                                        <tr>
                                            <th>Subcategory</th>
                                            <td>{productData?.subcategoryInfo?.name}</td>
                                        </tr>
                                        <tr>
                                            <th>Jiomart ID</th>
                                            <td>{productData?._doc?.jiomartid}</td>
                                        </tr>
                                        <tr>
                                            <th>Blinkit ID</th>
                                            <td>{productData?._doc?.blinkitid}</td>
                                        </tr>
                                        <tr>
                                            <th>Bigbasket ID</th>
                                            <td>{productData?._doc?.bigbasketid}</td>
                                        </tr>
                                        <tr>
                                            <th>Zepto ID</th>
                                            <td>{productData?._doc?.zeptoid}</td>
                                        </tr>
                                        <tr>
                                            <th>Swiggy Instamart ID</th>
                                            <td>{productData?._doc?.swiggyinstamartid}</td>
                                        </tr>
                                        <tr>
                                            <th>Amazon Fresh URL</th>
                                            <td>{productData?._doc?.amazonid}</td>
                                        </tr>
                                        <tr>
                                            <th>Flipkart Grocery URL</th>
                                            <td>{productData?._doc?.flipkartid}</td>
                                        </tr>
                                        <tr>
                                            <th>Description</th>
                                            <td>{productData?._doc?.description}</td>
                                        </tr>
                                        <tr>
                                            <th>Image URL</th>
                                            <td>{productData?._doc?.imageurl}</td>
                                        </tr>
                                        <tr>
                                            <th>Created Date</th>
                                            <td>{formatUTCDate(productData?._doc?.createddate)}</td>
                                        </tr>
                                        <tr>
                                            <th>Modified Date</th>
                                            <td>{formatUTCDate(productData?._doc?.modifieddate)}</td>
                                        </tr>
                                        <tr>
                                            <th>Created By</th>
                                            <td>{productData?._doc?.createdby}</td>
                                        </tr>
                                        <tr>
                                            <th>Modified By</th>
                                            <td>{productData?._doc?.modifiedby}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}
export default ViewProduct;
